import { monitoredOpen } from 'src/utils/sentry/navigation';

export const openNewTab = (url: string) => {
    monitoredOpen(url, 'homepage-link')
  };
